import { Card, Grid, Typography } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import errorIcon from 'images/error-icon.svg';
import warning from 'images/warning.svg';
import { translate } from 'containers/services/translate';
import {
  StyledTopCard,
  StyledText,
} from 'containers/CourtManagerLegalProceedings/styled-components';
import { COLORS } from 'constants/design';

export interface WarningCardProps {
  intl: IntlShape;
  message: { id: string };
  isWarning?: boolean;
  textParams?: any;
}
export const StyledWarningContainer = {
  padding: '12px 12px 12px 12px',
  backgroundColor: COLORS.LIGHT_ORANGE,
  marginBottom: 15,
  width: 'fit-content',
};
const styledWarningText = {
  color: COLORS.ORANGE_TEXT,
  fontSize: '14px',
  marginTop: 2,
};
const WarningCard: React.FC<WarningCardProps> = props => {
  return (
    <Card
      style={!props.isWarning ? StyledTopCard : StyledWarningContainer}
      elevation={0}
    >
      <Grid container direction="row" alignItems="center" spacing={1}>
        <Grid item>
          <img
            data-testId="icon-warningCard"
            src={!props.isWarning ? errorIcon : warning}
            alt="warning"
          />
        </Grid>
        <Grid item xs>
          <Typography style={!props.isWarning ? StyledText : styledWarningText}>
            {translate(
              props.message,
              props,
              props.textParams
                ? {
                    textParams: props.textParams,
                  }
                : {},
            )}
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );
};
export default injectIntl(WarningCard);
